module.exports = __webpack_public_path__ + "static/media/blog10_sm.33475fa5.webp";